import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { CONTEXT_ROOT } from '../../../constants';
import { PAGE_DIRECTORY } from '../../../services/filter/constants';

import { filterPartnerOnFirstLetter } from '../../../services/filter/actions';

import DirectoryPage from './DirectoryPage';
import HeadComponent from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';

// extract the letter from the url params
const extractLetter = (currentProps, nextProps) => {
    const letter = (currentProps && currentProps.match.params.letter) || null;
    const nextLetter = (nextProps && nextProps.match.params.letter) || null;

    return { letter, nextLetter };
};

export class LetterDirectoryPage extends React.Component {
    extractLetterAndDispatch(currentProps, nextProps) {
        const { letter, nextLetter } = extractLetter(currentProps, nextProps);

        if (nextLetter && nextLetter !== letter) {
            this.props.filterPartnerOnFirstLetter(PAGE_DIRECTORY, nextLetter);
        }
    }

    componentDidMount() {
        this.extractLetterAndDispatch(null, this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.extractLetterAndDispatch(this.props, nextProps);
    }

    render() {
        const { match, isCodePromo, i18nPage, i18nDirectoryPage } = this.props;
        const isOffline = match.params.type === PATH.OFFLINE;
        const isEbon = match.params.type === PATH.EBON;

        let title = i18nDirectoryPage.ONLINE_TITLE;
        if (isOffline) {
            title = i18nDirectoryPage.OFFLINE_TITLE;
        } else if (isEbon) {
            title = i18nDirectoryPage.EBON_TITLE;
        }

        return (
            <div>
                <HeadComponent
                    title={i18nPage.TITLE}
                    description={i18nPage.DESCRIPTION}
                    canonicalLink={`${CONTEXT_ROOT}${PATH.CASHBACK_PATH}/${match.params.type}/${PATH.ALPHA_PATH}/${match.params.letter}`}
                />
                <LocalizedBreadcrumbItem to={`${PATH.CASHBACK_PATH}/${match.params.type}`}>
                    {title}
                </LocalizedBreadcrumbItem>
                <LocalizedBreadcrumbItem to={match.url}>
                    {i18nPage.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <DirectoryPage
                    letter={match.params.letter || ''}
                    isCodePromo={isCodePromo}
                    isOffline={isOffline}
                    isEbon={isEbon}
                />
            </div>
        );
    }
}

LetterDirectoryPage.propTypes = {
    isCodePromo: PropTypes.bool,
    isOffline: PropTypes.bool,
    isEbon: PropTypes.bool
};

const mapStateToProps = state => {
    return {
        i18nPage: state.i18n.page.DIRECTORY.A_Z,
        i18nDirectoryPage: state.i18n.page.DIRECTORY.MOST_POPULAR
    };
};

const mapDispatchToProps = {
    filterPartnerOnFirstLetter
};

export default withTemplate(
    connect(mapStateToProps, mapDispatchToProps)(LetterDirectoryPage),
    PrimaryTemplate
);



// WEBPACK FOOTER //
// ./src/components/pages/directory/LetterDirectoryPage.js